<template>
  <div class="space-y-6">
    <router-link :to="{ name: 'SettingsBilling' }" class="btn btn-outline">
      &larr; Back to Billing
    </router-link>

    <alert v-if="$route.query.cancel" type="warning" icon="times-circle">
      Your checkout was cancelled. Nothing was charged and no changes were made to your subscription plan. You may try again, if you like.
    </alert>
    
    <div class="card">

      <div class="pb-6 card-header">
        Change Your Subscription Plan
      </div>

      <div class="p-6 border-t" v-for="product in products" :key="product.name">
        <div class="flex">
          <component :is="`Logo${product.name}`" class="w-10 h-10 mr-3" />
          <!-- <img v-if="product.name === 'Portal'" src="@/assets/img/logo-portal.svg" :alt="product.name" class="w-10 h-10">
          <img v-if="product.name === 'Radar'" src="@/assets/img/logo-radar.svg" :alt="product.name" class="w-10 h-10"> -->
          <div>
            <div class="leading-tight uppercase">
              <div class="font-bold text-gray-900">
                Fleetbeacon
              </div>
              <div class="font-medium" :class="product.color">
                {{ product.name }}
              </div>
            </div>
            <div class="mt-1 mb-3 text-gray-500">
              From <span class="inline-flex font-bold"><currency :value="product.prices[currency].metered" :currency-code="currency" :subunits-value="false" /></span> per {{ product.unit }} per month, billed monthly.<br>
              Starts at <span class="inline-flex font-bold"><currency :value="product.prices[currency].minimum" :currency-code="currency" :subunits-value="false" /></span>, which includes your first {{ product.units }}.
            </div>
            <div v-if="cart.some(item => item.id === product.id)" class="flex gap-x-2">
              <div class="opacity-75 btn btn-outline">
                <fa :icon="['far', 'check']" class="mr-2" /> Added to Plan
              </div>
              <button class="text-red-500 btn btn-text" @click="removeFromCart(product)">
                Remove
              </button>
            </div>
            <button v-else class="btn btn-secondary" @click="addToCart(product)">
              <fa :icon="['far', 'plus']" class="mr-2" /> Add {{ product.name }} to My Plan...
            </button>
          </div>
        </div>
      </div>

      <form class="p-6 border-t" @submit.prevent="checkout" v-if="line_items.length">
        <button type="submit" class="btn btn-primary" v-submitting="submitting">
          Complete Checkout &rarr;
        </button>
      </form>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'SettingsSubcription',

  computed: {
    ...mapGetters(['account']),

    currency () {
      const supportedCurrencies = ['USD', 'AUD', 'ZAR', 'EUR', 'GBP']
      if (supportedCurrencies.indexOf(this.account.currency)) {
        return this.account.currency
      } else {
        return 'USD'
      }
    },

    line_items () {
      return this.cart.map((item) => {
        return {
          price: item.prices[this.currency].id
        }
      })
    }
  },
  
  data () {
    return {
      cart: [],
      submitting: false,
      products: [
        {
          id: 'prod_KF6ULEnrUeqvvn',
          name: 'Portal',
          color: 'text-cyan-500',
          unit: 'order',
          units: '200 orders',
          prices: {
            AUD: {
              metered: 0.25,
              minimum: 50,
              id: 'price_1JacH5COPss6y1NXR0bIWOb6'
            },
            EUR: {
              metered: 0.25,
              minimum: 50,
              id: 'price_1JcBKNCOPss6y1NX81j6S1SI'
            },
            GBP: {
              metered: 0.25,
              minimum: 50,
              id: 'price_1JacH5COPss6y1NXR0bIWOb6'
            },
            USD: {
              metered: 0.25,
              minimum: 50,
              id: 'price_1JacH5COPss6y1NXR0bIWOb6'
            },
            ZAR: {
              metered: 2.50,
              minimum: 500,
              id: 'price_1JacH5COPss6y1NXR0bIWOb6'
            }
          }
        },
        {
          id: 'prod_KFAFIiJxiAEvJ8',
          name: 'Radar',
          color: 'text-blue-500',
          unit: 'vehicle',
          units: '10 vehicles',
          prices: {
            AUD: {
              metered: 5,
              minimum: 50,
              id: 'price_1JafuwCOPss6y1NXhM4VSsdm'
            },
            EUR: {
              metered: 5,
              minimum: 50,
              id: 'price_1JcBL8COPss6y1NXCNQYxw3I'
            },
            GBP: {
              metered: 5,
              minimum: 50,
              id: 'price_1JafuwCOPss6y1NXhM4VSsdm'
            },
            USD: {
              metered: 5,
              minimum: 50,
              id: 'price_1JafuwCOPss6y1NXhM4VSsdm'
            },
            ZAR: {
              metered: 50,
              minimum: 500,
              id: 'price_1JafuwCOPss6y1NXhM4VSsdm'
            }
          }
        }
      ]
    }
  },

  methods: {
    async checkout () {
      this.submitting = true
      try {
        const { data } = await this.$api.post(`account/${this.account.subdomain}/billing/checkout`, {
          line_items: this.line_items
        })
        window.location.href = data.url
      } catch (error) {
        this.submitting = false
      }
    },

    addToCart (product) {
      const inCart = this.cart.find((item) => item.id === product.id)
      if (!inCart) { this.cart.push(product) }
    },

    removeFromCart (product) {
      const index = this.cart.findIndex((item) => item.id === product.id)
      this.$delete(this.cart, index)
    }
  }
}
</script>

<style>

</style>